const { isToday, isYesterday, getMonth, getYear, getFullYear, getMonthFullName, formatDate } = require('./dateHelper');
const { toCamelCase } = require('./stringHelper');
const { DATE_FORMAT_WITH_DASHES_FIRST_YEAR } = require('../constants/index');
const Immutable = require('immutable');

/**
 * Goes through the array of transactions, classifying them by their date
 * @param  {Immutable List} immItems The transaction list
 * @return {Object}   and object with the current year items, and the old ones
 */
const classifyItemsByDate = (immItems, thisMonthKey, language,  dateFieldName = 'date') => {
    const date = new Date();
    const currentYear = date.getFullYear();
    const currentMonth = getMonth(date);

    const isRecent = item => {
        const itemDate = item.get(dateFieldName);
        return isToday(itemDate) || isYesterday(itemDate);
    };
    const isInFutureDate = item => {
        const itemDate =
            new Date(
                formatDate(item.get(dateFieldName), language, DATE_FORMAT_WITH_DASHES_FIRST_YEAR)
            );

        return !isRecent(item) && itemDate > date;
    };
    const isInOldYear = item => {
        const itemYear = getFullYear(item.get(dateFieldName));
        return !isInFutureDate(item) && itemYear !== currentYear;
    };
    const isInCurrentMonth = item => {
        const itemMonth = getMonth(item.get(dateFieldName));
        const itemYear = getYear(item.get(dateFieldName));
        return !isRecent(item) && !isInFutureDate(item) && itemMonth === currentMonth && itemYear === currentYear.toString().substring(2);
    };
    const isInCurrentYear = item => {
        const itemYear = getFullYear(item.get(dateFieldName));
        return !isRecent(item) && !isInFutureDate(item) && !isInCurrentMonth(item) && itemYear === currentYear;
    };
    const monthGrouper = item => {
        const itemMonth = getMonth(item.get(dateFieldName));
        return toCamelCase(getMonthFullName(itemMonth, language));
    };
    const yearGrouper = item => {
        return getFullYear(item.get(dateFieldName));
    };

    return {
        immFutureItems: immItems.filter(isInFutureDate),
        immRecentItems: immItems.filter(isRecent),
        immCurrentMonthItemsNotMap: immItems.filter(isInCurrentMonth),
        immCurrentMonthItems: Immutable.Map().set(thisMonthKey, immItems.filter(isInCurrentMonth)),
        immCurrentYearItems: immItems.filter(isInCurrentYear).groupBy(monthGrouper),
        immOldYearItems: immItems.filter(isInOldYear).groupBy(yearGrouper)
    }
};

module.exports = {
    classifyItemsByDate
};
